import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Quickchat = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.515 13.101c-2.405 0-4.408 2.004-4.408 4.408 0 2.404 2.003 4.407 4.408 4.407 2.404 0 4.407-2.003 4.407-4.407S10.919 13.1 8.515 13.1ZM2.204 17.51a6.285 6.285 0 0 1 6.31-6.311 6.285 6.285 0 0 1 6.311 6.31 6.285 6.285 0 0 1-6.31 6.312 6.285 6.285 0 0 1-6.311-6.311ZM8.515 27.326c-3.607 0-6.612 3.005-6.612 6.61v2.405c0 .2.2.4.4.4h12.422c.2 0 .4-.2.4-.4v-2.404c0-3.707-3.004-6.611-6.61-6.611ZM0 33.936c0-4.707 3.806-8.414 8.515-8.414 4.707 0 8.514 3.807 8.514 8.415v2.404c0 1.202-1.002 2.304-2.304 2.304H2.204C1.002 38.645 0 37.643 0 36.34v-2.404ZM21.737 14.003c0-.501.4-.902.902-.902h15.326c.5 0 .901.4.901.902 0 .5-.4.901-.901.901H22.639c-.501 0-.902-.4-.902-.901ZM21.737 19.512c0-.5.4-.901.902-.901h15.326c.5 0 .901.4.901.901s-.4.902-.901.902H22.639c-.501 0-.902-.401-.902-.902Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.265 6.19H22.338a5.814 5.814 0 0 0-5.81 5.81v9.616a5.814 5.814 0 0 0 5.81 5.81h1.803c.802 0 1.503.7 1.503 1.502v3.206c0 1.302 1.502 2.003 2.504 1.202l6.21-5.51c.602-.6 1.904-.4 2.605-.4 3.406 0 6.41-2.505 6.912-5.81.2-.601.1-8.715.1-9.617.1-3.105-2.504-5.81-5.71-5.81Zm4.007 14.224c0 2.804-2.304 5.209-5.209 5.209-.901 0-2.204-.1-3.005.3-.3-.1-6.11 5.209-6.511 5.51v-2.505c0-1.803-1.503-3.406-3.406-3.406h-1.803a4.019 4.019 0 0 1-4.007-4.006v-9.617a4.019 4.019 0 0 1 4.007-4.007h15.927a4.019 4.019 0 0 1 4.007 4.007v8.515Z"
  }));
});
Quickchat.displayName = 'Quickchat';
Quickchat.defaultProps = {
  'aria-label': 'Quickchat'
};
export default Quickchat;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Quickchat.js
// module id = 3889
// module chunks = 11